module.exports = __webpack_public_path__ + "img/heavy-rain.79bc3741.svg";